export const SET_HIDE_GO_TO_HY_EX = 'SET_HIDE_GO_TO_HY_EX';
export const SET_COLLAPSE_SIDE_TEST_DRAWER = 'SET_COLLAPSE_SIDE_TEST_DRAWER';
export const SET_IS_HEADER_BTN_INJECTED_BY_OTHER_PRODUCT =
  'SET_IS_HEADER_BTN_INJECTED_BY_OTHER_PRODUCT';
export const SET_DOCK_MODE = 'SET_DOCK_MODE';
